<script setup>
import { ref } from "vue";

const host = "https://staging-app.smicos.com/register";
const listDescription = ref({});
const listPackage = ref("");

const showTooltip = (list, item) => {
    listDescription.value = list;
    listPackage.value = item;
};

const hideTooltip = () => {
    listDescription.value = "";
};

const starter = [
    {
        id: 1,
        name: "3 Active Smicos Bots",
        description:
            "An active Smicos bot that is connected to any integration",
    },
    {
        id: 6,
        name: "Smicos Test Bot",
        description:
            "The Smicos Test Bot is used to test your bot’s performance and functionality",
    },
    {
        id: 11,
        name: "Website, Facebook, and Instagram Integration",
        description:
            "Smicos Easy Integration to Website, Facebook Messenger, and Instagram",
    },
    {
        id: 2,
        name: "5,000 Valid Chats",
        description:
            "A valid chat is one interaction by the Smicos bot. This excludes the Test Bot and Live Agent chats",
    },
    {
        id: 7,
        name: "Customer Database",
        description:
            "It is the memory bank that helps your chatbot remember details, preferences, and interactions with each user",
    },
    {
        id: 12,
        name: "Starter-Analytics and Data Reports",
        description:
            "Measures Smicos bot performance using real-time analytics and data",
    },
    {
        id: 3,
        name: "1 GB Storage",
        description: "Storage for the assets of your chatbot",
    },
    {
        id: 8,
        name: "Chat Archive",
        description:
            "Each chat is timestamped and preserved, creating a comprehensive record of the interactions between your chatbot and users",
    },
    {
        id: 13,
        name: "3 Roles (Admin, Sales, and Live Agent)",
        description:
            "Roles define the privileges and access levels for different individuals or groups interacting with your chatbot. (Roles Available: Admin, Sales, and Live Agent)",
    },
    {
        id: 4,
        name: "Unlimited Story Flow",
        description:
            "The number of created stories in the Smicos Visual Flow Builder",
    },
    {
        id: 9,
        name: "Transfer to Live Agent",
        description:
            "Ensures that users have the option for a real-time conversation with a knowledgeable human representative",
    },
    {
        id: 14,
        name: "Smicos Support",
        description:
            "A dedicated feature that ensures users receive timely help, answers to queries, and a guide whenever you have any concerns as a User",
    },
    {
        id: 5,
        name: "Easy Chat Builder",
        description:
            "The Smicos Visual Flow Builder is used for easy creation of conversations",
    },
    {
        id: 10,
        name: "Pre-made Templates",
        description:
            "Readily available templates for Lead Generation, Customer Service, and Hiring",
    },
    {
        id: 15,
        name: "Data Security",
        description:
            "Measures and practices designed to protect digital information from unauthorized access, corruption, or theft. It includes encryption, access controls, and security protocols to ensure data confidentiality, integrity, and availability.",
    },
    {
        id: 16,
        name: "Option for Add-ons",
        description:
            "A menu of additional features, services, or capabilities that you can selectively integrate into your Smicos bot, providing a customized and scalable solution",
    },
];
</script>

<template>
    <div class="bg-gradient-to-r from-[#384590] to-[#01ADED]">
        <div class="max-w-screen-xl p-4 mx-auto">
            <p
                class="text-white md:text-[50px] text-[35px] font-extrabold text-center leading-tight mb-4"
            >
                Smicos Starter Sale
            </p>
            <div
                class="grid p-6 mb-4 border-2 border-white sm:grid-cols-3 rounded-xl"
            >
                <div
                    v-for="list in starter"
                    class="flex gap-2 cursor-default group sm:last:col-start-3"
                    @mouseenter="showTooltip(list, `starter`)"
                    @mouseleave="hideTooltip"
                >
                    <div class="text-[#E1251B] group-hover:text-[#F2CD59]">
                        <svg
                            width="31"
                            height="30"
                            viewBox="0 0 31 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5.79004 15.7639L11.9439 21.875L25.79 8.125"
                                stroke="currentColor"
                                stroke-width="5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                    <div
                        class="relative group-hover:text-[#F2CD59] max-sm:w-full text-white"
                    >
                        <span>
                            {{ list.name }}
                        </span>
                        <div
                            v-if="
                                listDescription.id && listPackage === `starter`
                            "
                            class="absolute bottom-[100%] md:left-[100%] xs:left-[70%] left-[50%] z-[100] p-3 shadow-lg border-[1px] border-[#E1251B] rounded-md text-sm bg-white md:w-[20rem] w-[8rem] max-w-[20rem] text-left"
                            :class="[
                                list.id !== listDescription.id ? `hidden` : ``,
                            ]"
                        >
                            {{ list.description }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex gap-4 max-md:flex-col">
                <div class="flex flex-col items-center flex-1 gap-2">
                    <div
                        class="flex flex-col items-center justify-center w-full p-4 leading-none bg-white rounded-xl"
                    >
                        <div
                            class="flex items-end mb-2 text-[#E1251B] text-[30px] font-extrabold"
                        >
                            $ 42.75 / 3 months
                        </div>

                        <div class="">
                            <span>Originally valued at $114 for 3 months</span>
                        </div>
                    </div>
                    <a
                        :href="`${host}?checkoutPackage=Starter&advanceSubscriptionPeriod=3`"
                        class="flex items-center justify-center gap-2 bg-[#E1251B] rounded-full px-6 py-2 lg:w-full xs:w-[20rem] w-full"
                        target="_blank"
                    >
                        <div
                            class="text-[16px] text-white text-center font-semibold"
                        >
                            Subscribe
                        </div>
                        <ArrowUpRightIcon class="w-5 text-white" />
                    </a>
                </div>
                <div class="flex flex-col items-center flex-1 gap-2">
                    <div
                        class="flex flex-col items-center justify-center w-full p-4 leading-none bg-white rounded-xl"
                    >
                        <div
                            class="flex items-end mb-2 text-[#E1251B] text-[30px] font-extrabold"
                        >
                            $ 57 / 6 months
                        </div>

                        <div class="">
                            <span>Originally valued at $114 for 6 months</span>
                        </div>
                    </div>
                    <a
                        :href="`${host}?checkoutPackage=Starter&advanceSubscriptionPeriod=6`"
                        class="flex items-center justify-center gap-2 bg-[#E1251B] rounded-full px-6 py-2 lg:w-full xs:w-[20rem] w-full"
                        target="_blank"
                    >
                        <div
                            class="text-[16px] text-white text-center font-semibold"
                        >
                            Subscribe
                        </div>
                        <ArrowUpRightIcon class="w-5 text-white" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
